import { render } from "./ProductList.vue?vue&type=template&id=07aaea18"
import script from "./ProductList.js?vue&type=script&lang=js"
export * from "./ProductList.js?vue&type=script&lang=js"

import "./ProductList.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__